const RateCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-rate-criterion" */ '@/pages/base-info/feedback/rate-criterion/index.vue'
  )
const CreateRateCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-rate-criterion" */ '@/pages/base-info/feedback/rate-criterion/create.vue'
  )
const EditRateCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-rate-criterion" */ '@/pages/base-info/feedback/rate-criterion/edit.vue'
  )

export default {
  path: 'rate-criterion',
  meta: {
    label: 'feedbackCriterion',
    auth: 'rateCriterion'
  },
  component: {
    name: 'RateCriterion',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFeedbackRateCriterion',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: RateCriterion
    },
    {
      name: 'BaseInfoCreateFeedbackRateCriterion',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateRateCriterion
    },
    {
      name: 'BaseInfoEditFeedbackRateCriterion',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditRateCriterion,
      props: true
    }
  ]
}
